import { render, staticRenderFns } from "./MealItemsExport.vue?vue&type=template&id=4f234a28&scoped=true"
import script from "./MealItemsExport.vue?vue&type=script&lang=js"
export * from "./MealItemsExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f234a28",
  null
  
)

export default component.exports